import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FieldFactoryCheckrollWeightReportListing } from './Pages'

export const FieldFactoryCheckrollWeightReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={FieldFactoryCheckrollWeightReportListing} />
    </Fragment>
)